import axios from "axios";
import { mapState } from "vuex";
import { Toast, Dialog } from "vant";
import common from "../../assets/js/common";
import Captcha from "@/components/captcha";
import requestApi from "@/utils/requestApi";

export default {
  components: {
    Captcha
  },
  data() {
    return {
      loading: false,
      env: process.env,
      source: "", // detail 详情展示
      isCheck: true, // 当前登录人判断
      returnUrl: "",
      detail: {},
      showKeyboard: false,
      form: {
        lat: "", // 39.662263
        lon: "", // 118.197815
        orderId: "",
        signType: "1", // signType 1： 买家签署  2：自提人或者司机签署
        pickupCode: "",
        voucherUrlList: [],
        certificateNumber: "",
        signName: ""
      },
      isUpload: 0, // 1 必须上传凭证
      fileList: [],
      voucherUrlUploadedList: [],
      maxCount: 20,
      realPopup: false,
      disList: [],
      contractSignStatus: 0,
      signIdentityCard: "",
      smscode: "",
      phone: "",
      isTrue: 0,
      isVerification: 0,
      // 是否需要校验实名 0否 1是
      isCheckSignReal: 0,
      countDown: 10,
      // 是否已确认收货
      isReceiptOrder: 0,
      hasCaAgreement: false,
      caAgreementUrl: "",
      signUrl: "",
      caAgreementName: "上上签CA电子认证协议",
      agreementChecked: false,
      isAuthFile: false,
      authFilePopupShow: false,
      pendingNavigateUrl: "",
      authFileTemplateUrl: "https://nfs.nxin.com/cxt/CA_Authorization2606.docx",
      isAuth: true,
      authMobUrl: "",
      authTips: ""
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    // /vm/signature?orderId=xxxx&signType=x rest/order/queryElectronicReceipt
    const { orderId, signType, returnUrl, source, isTrue } = this.$route.query;
    this.source = source || "";
    this.isTrue = isTrue || 0;
    this.form.orderId = orderId || "";
    this.form.signType = signType || "1";
    this.returnUrl = returnUrl ? decodeURIComponent(returnUrl) : "";
    this.getBasicCa();
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 0
    });
    if (source !== "detail") {
      this.checkUser();
    }
  },
  mounted() {
    this.getLocation();
  },
  watch: {
    // contractSignStatus() {
    //   console.log(this.contractSignStatus);
    //   if (this.contractSignStatus === 2 && !this.isTriggerSign) {
    //     timer = setInterval(() => {
    //       this.countDownSubmit();
    //     }, 1000);
    //   }
    // }
  },
  methods: {
    getBasicCa() {
      const { orderId } = this.form;
      if (!orderId) {
        return Promise.resolve();
      }
      return requestApi
        .post("sctrading/contract/getBasicCa", {
          returnUrl: window.location.href,
          orderId,
          contractType: "receive"
        })
        .then(res => {
          const { code, data } = res;
          if (code == 0) {
            const { url, name, isAuthFile, templateUrl, authFileUrl, authMobUrl, isAuth, tips, isExpired } =
              data || {};
            if (isExpired === false && url) {
              // window.location.href = url;
              this.signUrl = url;
              return;
            }
            if (url) {
              this.caAgreementUrl = url;
              this.caAgreementName = name || "上上签CA电子认证协议";
              this.hasCaAgreement = true;
            }
            this.isAuthFile = !!isAuthFile;
            this.authFileTemplateUrl = templateUrl || authFileUrl || this.authFileTemplateUrl;
            if (typeof isAuth !== "undefined") {
              this.isAuth = isAuth;
            }
            this.authMobUrl = authMobUrl || "";
            this.authTips = tips || "";
          }
        });
    },
    goToCaUrl(url) {
      if (!url) {
        Toast("协议链接获取中，请稍后重试");
        return;
      }
      if (this.isAuthFile) {
        this.pendingNavigateUrl = url;
        this.authFilePopupShow = true;
        return;
      }
      window.location.href = url;
    },
    confirmAuthFileNavigate() {
      this.authFilePopupShow = false;
      if (this.pendingNavigateUrl) {
        window.location.href = this.pendingNavigateUrl;
      }
    },
    downloadAuthTemplate() {
      if (this.authFileTemplateUrl) {
        window.location.href = this.authFileTemplateUrl;
        return;
      }
      Toast("模版下载链接获取中，请稍后重试");
    },
    openCaAgreement() {
      if (this.caAgreementUrl) {
        this.agreementChecked = true;
        this.goToCaUrl(this.caAgreementUrl);
        return;
      }
      Toast("协议链接获取中，请稍后重试");
    },
    // 检查当前登录人
    checkUser() {
      const { orderId, signType } = this.form;
      this.$store
        .dispatch("order/signature/signCheckReceiptUser", {
          orderId,
          signType
        })
        .then(res => {
          this.loading = true;
          console.log("res", res);
          const { code, data } = res;
          if (code === "0") {
            this.isCheck = true;
          } else {
            this.isCheck = false;
            this.disList = data || [];
          }
          if (this.isCheck) {
            this.$store
              .dispatch("order/signature/getOrderQyPassed", {
                orderId
              })
              .then(res1 => {
                if (!res1.data) {
                  Dialog.alert({ message: res1.msg });
                }
              });
          }
        })
        .finally(() => {
          Toast.clear();
        });
    },
    getDetail() {
      const { orderId, lat, lon } = this.form;
      this.$store
        .dispatch("order/signature/queryElectronicReceipt", {
          orderId,
          lat,
          lon
        })
        .then(data => {
          this.loading = true;
          // isSign==1  已签署 isSign==0  未签署
          const { isUploadNeedVoucher, receiptOrder, isCheckSignReal, isReceiptOrder } = data;
          this.source = receiptOrder.isSign === 1 ? "detail" : "";
          this.isUpload = isUploadNeedVoucher;
          this.contractSignStatus = receiptOrder.contractSignStatus;
          this.voucherUrlUploadedList = receiptOrder.voucherUrlUploadedList || [];
          this.detail = receiptOrder || {};
          this.phone = receiptOrder.phone || "";
          this.form.signName = receiptOrder.signName || "";
          this.isCheckSignReal = isCheckSignReal || 0;
          this.isVerification = receiptOrder.isVerification || 0;
          if (receiptOrder.voucherUrlList) {
            this.fileList = receiptOrder.voucherUrlList
              .map(item => {
                if (/(zip)$/.test(item)) {
                  return "https://files.nxin.com/mobile/public/zip.png";
                }
                return item;
              })
              .map(item => ({
                url: item
              }));
          }
          this.isReceiptOrder = isReceiptOrder || 0;
          if (this.contractSignStatus === 2) {
            Dialog.alert({
              message:
                "请确认操作人姓名与身份证号是否匹配，核实后重新发起签署，如有疑问请联系客服 400-810-5353。"
            }).then(() => {});
          }
          if (this.contractSignStatus === 1 && this.isReceiptOrder === 0) {
            Toast.loading({
              mask: true,
              message: "确认收货中。。。",
              duration: 0
            });
            this.receiptOrderGoodsSubmit();
          }
        })
        .finally(() => {
          Toast.clear();
        });
    },
    // 上传图片
    afterRead(file) {
      const { orderId } = this.form;
      const count = this.fileList.length;
      let fileArray = [];
      if (Array.isArray(file)) {
        fileArray = file;
        if (file.length + this.voucherUrlUploadedList.length + count > this.maxCount) {
          fileArray = file.slice(0, this.maxCount);
        }
      } else {
        fileArray.push(file);
      }
      fileArray.forEach(item => {
        item.status = "uploading";
        item.message = "上传中...";
        // 此时可以自行将文件上传至服务器
        const formData = new FormData();
        formData.append("file", item.file);
        axios
          .post(`${process.env.VUE_APP_APP}file/uploadFile.do`, formData, {
            headers: { "content-type": "multer/form-data" }
          })
          .then(res => {
            item.status = "";
            item.message = "";
            const fileUrl = res.data.substring(res.data.indexOf("http"));
            item.url = fileUrl;
            this.$store
              .dispatch("order/signature/checkUploadOrderVoucher", {
                orderId,
                voucherImgUrl: fileUrl
              })
              .then(res1 => {
                console.log("res1", res1);
                if (res1.code !== "0") {
                  console.log("fileArray", fileArray);
                  this.fileList.splice(this.fileList.length - 1, 1);
                  Dialog.alert({ message: res1.msg });
                }
              });
          })
          .catch(() => {
            file.status = "failed";
            file.message = "上传失败";
          });
      });
    },
    // 返回布尔值
    beforeRead(file) {
      let fileArray = [];
      if (Array.isArray(file)) {
        fileArray = file;
      } else {
        fileArray.push(file);
      }
      console.log("fileArray", fileArray);
      for (const item of fileArray) {
        if (item.size && item.size >= 10 * 1024 * 1024) {
          Toast("上传文件过大，文件大小不能大于10M");
          return false;
        }
        if (item.type !== "image/jpeg" && item.type !== "image/jpg" && item.type !== "image/png") {
          Toast("请上传正确的图片格式");
          return false;
        }
      }
      return true;
    },
    // 获取定位
    getLocation() {
      const that = this;
      if (isInZnt()) {
        znt.getLocation({
          success(res) {
            const { lat, lng } = res;
            that.form.lat = lat;
            that.form.lon = lng;
            that.getDetail();
          },
          fail(res) {
            that.getDetail();
            console.log("智农通获取经纬度失败", res);
          }
        });
      } else if (common.isInWeiXin()) {
        // 微信环境下获取有延迟
        setTimeout(() => {
          wx.getLocation({
            type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success(res) {
              const { latitude, longitude } = res;
              console.log("微信获取经纬度", res);
              that.form.lat = latitude;
              that.form.lon = longitude;
              that.getDetail();
            },
            fail(res) {
              that.getDetail();
              console.log("微信获取经纬度失败", res);
            }
          });
        }, 500);
      } else {
        this.getDetail();
      }
    },

    // 自提码输入
    onInput(key) {
      const { pickupCode } = this.form;
      this.form.pickupCode = (pickupCode + key).slice(0, 4);
    },
    onDelete() {
      const { pickupCode } = this.form;
      this.form.pickupCode = pickupCode.slice(0, pickupCode.length - 1);
    },
    navigateToAuthMobUrl() {
      if (!this.authMobUrl) {
        Toast("认证链接获取中，请稍后重试");
        return;
      }
      const retUrl = encodeURIComponent(window.location.href);
      const separator = this.authMobUrl.indexOf("?") > -1 ? "&" : "?";
      window.location.href = `${this.authMobUrl}${separator}retUrl=${retUrl}`;
    },
    receiveSubmit() {
      if (this.hasCaAgreement && !this.agreementChecked) {
        Toast(`请先阅读并同意《${this.caAgreementName}》`);
        return;
      }
      if (this.isAuth === false) {
        Dialog.confirm({
          message: this.authTips || "请先完成实名认证"
        }).then(() => {
          this.navigateToAuthMobUrl();
        });
        return;
      }
      const { orderId } = this.form;
      this.$store
        .dispatch("order/signature/getOrderQyPassed", {
          orderId
        })
        .then(res => {
          if (res.data) {
            this.receiveSubmitApi();
          } else {
            Dialog.alert({ message: res.msg });
          }
        });
    },
    receiveSubmitApi() {
      const {
        form,
        detail,
        smscode,
        fileList,
        isUpload,
        isVerification,
        voucherUrlUploadedList
      } = this;
      if (!form.pickupCode && form.signType === "2") {
        Toast("请先输入收货码");
        return;
      }
      if (!fileList.length && isUpload === 1 && !voucherUrlUploadedList.length) {
        Toast("请先上传凭证");
        return;
      }
      if (!detail.signIdentityCard && this.signIdentityCard === "") {
        Toast("请填写身份证号,操作人姓名和身份证号需匹配且真实有效");
        return;
      }
      if (detail.userArchiveName !== detail.signName) {
        Toast("买家填写的姓名与操作人在系统实名信息不一致，无法代确认收货");
        return;
      }
      // 调用submitCaptcha 并获取到子级this.isTrue 的值
      if (form.signType === "2" && isVerification === 1) {
        if (smscode === "") {
          Toast("请输入验证码");
          return;
        }
        this.$store
          .dispatch("captcha/submitCaptcha", {
            phone: this.phone,
            busType: 0,
            codeNum: this.smscode
          })
          .then(res => {
            if (res.code === 1) {
              this.isTrue = 1;
              this.submitApi();
            } else {
              this.isTrue = 0;
              Toast(res.msg);
            }
          });
      } else {
        this.submitApi();
      }
    },
    submitApi() {
      const { form, fileList } = this;
      const voucherUrlList = fileList.map(item => item.url);
      Toast.loading({
        mask: true,
        message: "签署确认中...",
        duration: 0
      });
      this.form.certificateNumber = this.signIdentityCard;
      this.$store
        .dispatch("order/signature/signElectronicReceipt", {
          ...form,
          voucherUrlList
        })
        .then(res => {
          const { code, msg } = res;
          setTimeout(() => {
            if (code === "0") {
              this.getBasicCa().then(() => {
                Toast.clear();
                window.location.href = this.signUrl;
              });
            } else if (code === "1002") {
              // 未实名
              Toast.clear();
              this.realPopup = true;
            } else if (code === "1004") {
              Toast.clear();
              Toast("下单主体（企业）未实名");
            } else {
              Toast.clear();
              Toast(msg);
            }
          }, 100);
        })
        .catch(() => {
          Toast.clear();
        });
    },
    receiptOrderGoods() {
      const { orderId } = this.form;
      this.$store
        .dispatch("order/signature/getOrderQyPassed", {
          orderId
        })
        .then(res => {
          if (res.data) {
            Dialog.confirm({
              title: "提示",
              message:
                "点击“确定”，即视为您（收货人）按照买家实际下单的具体信息（包括但不限于货品的品类、数量、质量标准、自提车辆信息等）完成收货，请勿将货品转让给其他人， 且不得进行套现等不正当的行为。请您务必确保操作准确无误!否则，由此产生的风险和责任将由您自行承担。"
            }).then(() => {
              this.receiptOrderGoodsSubmit();
            });
          } else {
            Dialog.alert({ message: res.msg });
          }
        });
    },
    receiptOrderGoodsSubmit() {
      const { form } = this;
      this.$store
        .dispatch("order/signature/receiptOrderGoods", {
          ...form
        })
        .then(res => {
          const { code, msg } = res;
          setTimeout(() => {
            if (code === "0") {
              Toast.success("确认收货成功！");
              // this.routerBack();
              this.getDetail();
            } else {
              Toast(msg);
            }
          }, 100);
        })
        .finally(() => {
          Toast.clear();
        });
    },
    routerBack() {
      const { env, returnUrl } = this;
      if (returnUrl) {
        window.location.href = returnUrl;
      } else {
        window.location.href = `${env.VUE_APP_APP}mob/order/person/orderListNew?type=0`;
      }
    },

    routerClick(type) {
      if (type === "znt") {
        window.location.href = "https://znt.nxin.com/m/";
      } else if (type === "jr") {
        const retUrl = encodeURIComponent(window.location.href);
        const url = `${this.env.VUE_APP_MJR}yue_openAccount_auth.html?retUrl=${retUrl}`;
        window.location.href = url;
      }
    },
    // 全部提货订单

    routerAllDeliveryOrder() {
      window.location.href = `${process.env.VUE_APP_SC}vm2/vehicle/order/order`;
    },

    // 退出登录
    logBackIn() {
      // https://cas.t.nxin.com/cas/logout?service=xxx
      window.location.href = `${this.env.VUE_APP_CAS_NEW}cas/logout?service=${encodeURIComponent(
        window.location.href
      )}`;
    }
    // countDownSubmit() {
    //   if (this.countDown <= 0 || this.contractSignStatus === 1) {
    //     window.clearInterval(timer);
    //     this.isTriggerSign = true;
    //     if (this.isTriggerSign && this.contractSignStatus !== 1) {
    //       Dialog.alert({
    //         message: "请确认签收人姓名与身份证号是否匹配，核实后重新发起签署，如有疑问请联系客服 400-810-5353。"
    //       }).then(() => {
    //       });
    //     }
    //   } else {
    //     // eslint-disable-next-line no-plusplus
    //     this.countDown = this.countDown - 1;
    //     if (this.countDown % 3 === 0) {
    //       this.getDetail();
    //     }
    //   }
    // }
  }
};
